<template>
  <div class="Container">
    <b-row
      ><b-col><h2>Device Calibration Report</h2></b-col></b-row
    >
    <b-row
      ><b-col
        ><p class="explain">
          This report will show devices with upcoming calibrations in selected
          location.
        </p></b-col
      ></b-row
    >
    <hr />
    <b-row>
      <b-col>Select Time Period to show</b-col>
    </b-row>
    <b-row>
      <b-col cols="3"
        ><b-form-select
          v-model="selectedfilter"
          :options="filteroptions"
          class="mb-3"
          value-field="item"
          text-field="name"
        ></b-form-select
      ></b-col>
      <b-col
        ><b-button
          size="sm"
          variant="outline-secondary"
          v-on:click="applyfilter()"
          >Apply filter</b-button
        >
        <b-button
          size="sm"
          variant="outline-secondary"
          v-on:click="clearfilter()"
          >Clear filter</b-button
        ></b-col
      ></b-row
    >
    <hr />
    <b-row class="text-center"
      ><b-col cols="1"></b-col><b-col><h4>Results</h4></b-col>
      <b-row
        ><b-col cols="1"
          ><img
            id="menuGraphic"
            align="right"
            src="../../assets/PDFIconSmall.png"
            v-on:click="createPDF()"/></b-col></b-row
    ></b-row>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
    ></b-pagination>
    <b-table
      id="ResultsTable"
      :fields="this.fields"
      :items="this.reportvalues"
      :per-page="perPage"
      :current-page="currentPage"
      empty-text="There are no results for current filter"
      no-border-collapse
      hover
      show-empty
      responsive
      small
      class="text-center"
    >
    </b-table>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="2400"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="780px"
      :html-to-pdf-options="htmlToPdfOptions"
      ref="html2pdf"
    >
      <section slot="pdf-content">
        <b-row 
          ><b-col cols="8" align-self="center"><h3>Clarence Calibration Report</h3></b-col><b-col cols="4">
            <img
               src="../../assets/LogoOnly.png"
              style="height:120px; margin: none; padding: none;"/></b-col
        ></b-row>
        <b-row class="text-left"><b-col cols="6"><h5>Location: {{ this.selectedlocation }}</h5></b-col></b-row>
        <b-row class="text-left"><b-col cols="6"><h5>Generated: {{ this.now }}</h5></b-col></b-row>
        <hr />
        <b-table
          id="ResultsTable"
          :fields="this.fields"
          :items="this.reportvalues"
          empty-text="There are no results for current filter"
          no-border-collapse
          hover
          show-empty
          responsive
          small
          class="text-center"
        >
        </b-table>
        <hr />
        <b-row class="text-center"
          ><b-col>Generated from Seraph Protect</b-col></b-row
        >
      </section>
    </VueHtml2pdf>
  </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
export default {
  computed: {
    htmlToPdfOptions() {
      return {
        margin: 2,
        filename: "CalibrationReport.pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        pagebreak: { mode: "avoid-all", after: ".avoidThisRow" },
      };
    },
    rows() {
      return this.reportvalues.length;
    },
  },

  components: {
    VueHtml2pdf,
  },

  data() {
    return {
      ReportReady: true,
      perPage: 15,
      currentPage: 1,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      selectedfilter: 1,
      filteroptions: [
        { item: "1", name: "1 month" },
        { item: "2", name: "2 months" },
        { item: "3", name: "3 months" },
      ],
      reportvalues: [],
      fields: [
        { key: "DeviceName", label: "Device" },
        { key: "Room", label: "Room/Area" },
        { key: "Location", label: "Location Note" },
        { key: "CalibrationDate", label: "Last Calibrated" },
        { key: "NextCalibration", label: "Next Due" },
        { key: "CalibrationStatus", label: "Status" },
      ],
      now: null,
    };
  },

  async mounted() {
    this.ReportReady = false
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/reports";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      Report: "device_calibrations",
      Location: this.selectedlocation,
      Filters: [this.selectedfilter],
      RequestType: "",
      RequestVariable: "",
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        let responsearray = response.data.Values;
        this.reportvalues = [];

        for (let i = 0; i < responsearray.length; i++) {
          let dateString = responsearray[i][7];
          let splitDate = dateString.split("/");
          let month = splitDate[1] - 1; //Javascript months are 0-11

          let dateplusyear = new Date(splitDate[2], month, splitDate[0]);
          dateplusyear.setFullYear(dateplusyear.getFullYear() + 1);
          let today = new Date();
          let calstatus = "";

          if (today > dateplusyear) {
            calstatus = "Overdue";
          } else {
            calstatus = "Upcoming";
          }

          this.reportvalues.push({
                DeviceName: responsearray[i][1],
                Room: responsearray[i][3],
                Location: responsearray[i][2],
                CalibrationDate: responsearray[i][7],
                NextCalibration: dateplusyear.toLocaleDateString(),
                CalibrationStatus: calstatus
          })  
        }
        let NewArray = this.RemoveDuplicates(this.reportvalues)
        this.reportvalues = NewArray
        this.ReportReady = true
      });
  },

  methods: {
    createPDF() {
      let nowstamp = new Date();
      this.now = nowstamp.toLocaleString();
      this.$refs.html2pdf.generatePdf();
    },

    RemoveDuplicates(arr){
      let newArr = Array.from(new Set(arr.map(JSON.stringify)), JSON.parse)      
      return newArr;
    },

    applyfilter() {
      this.ReportReady = false
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/reports";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        Report: "device_calibrations",
        Location: this.selectedlocation,
        Filters: [this.selectedfilter],
        RequestType: "",
        RequestVariable: "",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          let responsearray = response.data.Values;
        this.reportvalues = [];

        for (let i = 0; i < responsearray.length; i++) {
          let dateString = responsearray[i][7];
          let splitDate = dateString.split("/");
          let month = splitDate[1] - 1; //Javascript months are 0-11

          let dateplusyear = new Date(splitDate[2], month, splitDate[0]);
          dateplusyear.setFullYear(dateplusyear.getFullYear() + 1);
          let today = new Date();
          let calstatus = "";

          if (today > dateplusyear) {
            calstatus = "Overdue";
          } else {
            calstatus = "Upcoming";
          }

          this.reportvalues.push({
                DeviceName: responsearray[i][1],
                Room: responsearray[i][3],
                Location: responsearray[i][2],
                CalibrationDate: responsearray[i][7],
                NextCalibration: dateplusyear.toLocaleDateString(),
                CalibrationStatus: calstatus
          })  
        }
        let NewArray = this.RemoveDuplicates(this.reportvalues)
        this.reportvalues = NewArray
        this.ReportReady = true
        });
    },

    clearfilter() {
      this.selectedfilter = 1;
      this.ReportReady = false

      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/reports";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        Report: "device_calibrations",
        Location: this.selectedlocation,
        Filters: [this.selectedfilter],
        RequestType: "",
        RequestVariable: "",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          let responsearray = response.data.Values;
        this.reportvalues = [];

        for (let i = 0; i < responsearray.length; i++) {
          let dateString = responsearray[i][7];
          let splitDate = dateString.split("/");
          let month = splitDate[1] - 1; //Javascript months are 0-11

          let dateplusyear = new Date(splitDate[2], month, splitDate[0]);
          dateplusyear.setFullYear(dateplusyear.getFullYear() + 1);
          let today = new Date();
          let calstatus = "";

          if (today > dateplusyear) {
            calstatus = "Overdue";
          } else {
            calstatus = "Upcoming";
          }

          this.reportvalues.push({
                DeviceName: responsearray[i][1],
                Room: responsearray[i][3],
                Location: responsearray[i][2],
                CalibrationDate: responsearray[i][7],
                NextCalibration: dateplusyear.toLocaleDateString(),
                CalibrationStatus: calstatus
          })  
        }
        let NewArray = this.RemoveDuplicates(this.reportvalues)
        this.reportvalues = NewArray
        this.ReportReady = true 
        });
    },
    ReportLoaded() {
      if (this.ReportReady == true){
        this.$emit("ReportLoad", "Loaded");
      } else {
        this.$emit("ReportLoad", "Loading");
      }
    },
  },

  watch: {
    ReportReady() {
    this.ReportLoaded();
    },
  },
};
</script>

<style scoped>
p.explain {
  color: gray;
  font-size: small;
}

.pagination {
  font-size: small;
}
#menuGraphic {
  cursor: pointer;
}
</style>
